// removed by extract-text-webpack-plugin
module.exports = {"root":"a5eAVLd","iconSvg":"_1WOK0CK","count":"_1F0B_eR","name":"_1k46rN6"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/DashboardHeading/DashboardHeading.less
 ** module id = 771
 ** module chunks = 0
 **/